<router-outlet></router-outlet> 
<app-fullscreen-image></app-fullscreen-image>
<app-bastani-loading loading="{{loading}}"></app-bastani-loading>
